/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ACADEMIC` - Academic
 * * `FOR_PROFIT` - For-Profit
 * * `NON_PROFIT` - Non-profit
 * * `PUBLIC` - Public
 */
export enum HospitalOwnershipEnum {
    ACADEMIC = 'ACADEMIC',
    FOR_PROFIT = 'FOR_PROFIT',
    NON_PROFIT = 'NON_PROFIT',
    PUBLIC = 'PUBLIC',
}
